import { useLocation, useNavigate } from "react-router-dom";
import { Box, Paper, Button, Center, Text } from "@mantine/core";
import CollaborationPaymentSuccessContent from "./CollaborationPaymentSuccessContent";
import { PAYMENT_SUCCESS_MODAL_MAX_WIDTH } from "./CollaborationPaymentSuccessModal";
import type { CollaborationPaymentSuccessData } from "../hooks/useCollaborationEngagementPayment";

export default function PaymentSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const paymentData = location.state?.paymentData as CollaborationPaymentSuccessData | undefined;

  if (!paymentData) {
    return (
      <Center mih="60vh" px="md">
        <Box ta="center">
          <Text c="dimmed" mb="md">
            No payment details found. Return to your collaborations to continue.
          </Text>
          <Button onClick={() => navigate("/collaborations")}>Go to Collaborations</Button>
        </Box>
      </Center>
    );
  }

  return (
    <Box py={{ base: "md", sm: "xl" }} px="md">
      <Paper
        radius="lg"
        p={{ base: "md", sm: "xl" }}
        maw={PAYMENT_SUCCESS_MODAL_MAX_WIDTH}
        w="100%"
        mx="auto"
        withBorder
        style={{ borderColor: "#E2E8F0" }}
      >
        <CollaborationPaymentSuccessContent paymentData={paymentData} showCloseButton={false} />
      </Paper>
    </Box>
  );
}
